import { useState } from "react";
import { passwordValidation } from "../../Common/Validations";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../../Redux/Slice/Authentication/ChangePasswordSlice";
import { Loader } from "../../Common/Loader";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import { OpenEye } from "../../Assets/svgs/OpenEye";
import { CloseEye } from "../../Assets/svgs/CloseEye";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { setUnsavedChanges } from "../../Redux/Slice/Common/SelectedTabSlice";
import { saveCurrentUserData } from "../../Redux/Slice/Common/CurrentUserSlice";

export const ChangePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [new2Password, setNew2Password] = useState("");
  const [passwordError, setPasswordError] = useState({
    current: "",
    new: "",
    new2: "",
  });
  const [passwordType2, setPasswordType2] = useState(false);
  const [passwordType, setPasswordType] = useState(false);
  const [passwordType3, setPasswordType3] = useState(false);
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [confirmModel, setCOnfirmModel] = useState(false);

  const handleChangeCurrent = async (e) => {
    const { value } = e.target;
    const formattedValue = value.trim()
    setCurrentPassword(formattedValue);
    await dispatch(setUnsavedChanges(true));
    const isValid = passwordValidation(formattedValue);
    if (isValid || formattedValue === "") {
      setPasswordError({ ...passwordError, current: "" });
    } else {
      setPasswordError({
        ...passwordError,
        current:
          "Password must be 8 characters long and include at least one lowercase letter, one uppercase letter, one number, and one special character",
      });
    }
  };
  const handleChangeNew = async (e) => {
    const value = e.target.value;
    const formattedValue = value.trim()
    setNewPassword(formattedValue);
    dispatch(setUnsavedChanges(true));
    const isValid = passwordValidation(formattedValue);
    let errors = passwordError;
    if (isValid || formattedValue === "") {
      errors = { ...passwordError, new: "" };
    } else {
      errors = {
        ...passwordError,
        new: "Password must be 8 characters long and include at least one lowercase letter, one uppercase letter, one number, and one special character",
      };
    }
    if (new2Password && (formattedValue !== new2Password)) {
      errors.new2 = "Passwords don't match";
    } else {
      errors.new2 = "";
    }
    setPasswordError(errors);
  };
  const handleChangeNew2 = async (e) => {
    const value = e.target.value;
    const formattedValue = value.trim()
    setNew2Password(formattedValue);
    dispatch(setUnsavedChanges(true));
    if (
      (formattedValue.match(newPassword) && newPassword.match(formattedValue)) ||
      formattedValue === ""
    ) {
      setPasswordError({ ...passwordError, new2: "" });
    } else {
      setPasswordError({
        ...passwordError,
        new2: "Passwords don't match",
      });
    }
  };

  const handleSubmit = async () => {
    setCOnfirmModel(false);
    await dispatch(setUnsavedChanges(false));
    setIsLoading(true);
    const body = {
      userId: userData.id,
      body: {
        password: currentPassword,
        newPassword: newPassword,
      },
    };
    const result = await dispatch(changePassword(body));
    if (
      changePassword.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      let userData2 = JSON.parse(localStorage.getItem("userData"));
      userData2.access_token = result.payload.data.access_token;
      localStorage.setItem("userData", JSON.stringify(userData2));
      dispatch(saveCurrentUserData(userData2));
      setSuccessMessage("Your password has been changed successfully.");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        navigate(-1);
      }, 1500);
    } else {
      //TODO: error popup here
      setIsLoading(false);
      setErrorMessage(
        result?.payload?.error?.message
          ? result?.payload?.error?.message
          : "Something went wrong."
      );
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  const handleUpdateClicked = () => {
    setCOnfirmModel(true);
  };
  const handelCancel = () => {
    setCOnfirmModel(false);
  };
  return (
    <div className="page__body">
      {isLoading ? <Loader /> : ""}
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {confirmModel ? (
        <ConfirmModel
          onAccept={handleSubmit}
          yes={"Yes"}
          no={"No"}
          onReject={handelCancel}
          title="Update Password!"
          message="Are you sure you want to update the password?"
        />
      ) : (
        ""
      )}
      <div className="details">
        <div className="form">
          <section className="form__section">
            <h1 className="form__section__title">Change Password</h1>
            <div className="formRow formRow__3">
              <div className="formCol">
                <div className="form__Field">
                  <label for="currentPassword" className="form__label">
                    Current Password<span style={{ color: "red" }}> * </span>
                  </label>
                  <div className="form__groupField">
                    <input
                      type={passwordType ? "text" : "password"}
                      id="currentPassword"
                      name="currentPassword"
                      value={currentPassword}
                      onChange={handleChangeCurrent}
                      className="form__input form__input--sm"
                      placeholder="Current Password"
                      maxLength={16}
                    />
                    <button
                      className="btn"
                      onClick={(e) => {
                        setPasswordType(!passwordType);
                      }}
                    >
                      {passwordType ? <OpenEye /> : <CloseEye />}
                    </button>
                  </div>
                </div>
                <div className="form__error">{passwordError.current}</div>
              </div>
              <div className="formCol">
                <div className="form__Field">
                  <label for="newPassword" className="form__label">
                    New Password<span style={{ color: "red" }}> * </span>
                  </label>
                  <div className="form__groupField">
                    <input
                      type={passwordType2 ? "text" : "password"}
                      id="newPassword"
                      name="newPassword"
                      value={newPassword}
                      onChange={handleChangeNew}
                      className="form__input form__input--sm"
                      placeholder="New Password"
                      maxLength={16}
                    />
                    <button
                      className="btn"
                      onClick={(e) => {
                        setPasswordType2(!passwordType2);
                      }}
                    >
                      {passwordType2 ? <OpenEye /> : <CloseEye />}
                    </button>
                  </div>
                </div>
                <div className="form__error">{passwordError.new}</div>
              </div>
              <div className="formCol">
                <div className="form__Field">
                  <label for="ReEnterPassword" className="form__label">
                    Re-enter Password<span style={{ color: "red" }}> * </span>
                  </label>
                  <div className="form__groupField">
                    <input
                      type={passwordType3 ? "text" : "password"}
                      id="ReEnterPassword"
                      name="new2Password"
                      value={new2Password}
                      onChange={handleChangeNew2}
                      className="form__input form__input--sm"
                      placeholder="Re-enter Password"
                      maxLength={16}
                    />
                    <button
                      className="btn"
                      onClick={(e) => {
                        setPasswordType3(!passwordType3);
                      }}
                    >
                      {passwordType3 ? <OpenEye /> : <CloseEye />}
                    </button>
                  </div>
                </div>
                <div className="form__error">{passwordError.new2}</div>
              </div>
            </div>
            <div className="btn__group">
              <button
                className="btn btn__primary"
                type="submit"
                disabled={
                  currentPassword === "" ||
                  newPassword === "" ||
                  new2Password === "" ||
                  passwordError.current != "" ||
                  passwordError.new != "" ||
                  passwordError.new2 != ""
                }
                onClick={handleUpdateClicked}
              >
                Update Password
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
